import { AdminAbility } from '@repo/sdk/backoffice-abilities'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'
import { requireAdminPermission } from '@/modules/permissions/lib/require-admin-permission'

export const Route = createFileRoute('/(private)/invii')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-sending:page_title'
				)
			}
		]
	}),
	beforeLoad: requireAdminPermission([AdminAbility.SendingMonitor]),
	staticData: { breadcrumb: 'admin-sending:page_title' },
	component: () => <Outlet />
})
